module.exports = __webpack_public_path__ + "static/img/5.22a88be8.png";